<script>

export default {
  methods: {
    uniqueId() {
      return Math.floor(Date.now() * Math.random()).toString()
    },
    refreshPage() {
      location.reload();
    },
    identificationToPattern: function (value) {
      if (value) {
        //if CPF
        if (value.length === 11) {
          value = value.substring(0, 3) + '.' + value.substring(3, 6) + '.' + value.substring(6, 9) + '-' + value.substring(9, 11);

          //if CNPJ
        } else if (value.length === 14) {
          value = value.substring(0, 2) + '.' + value.substring(2, 5) + '.' + value.substring(5, 8) + '/' + value.substring(8, 12) + '-' + value.substring(12, 14);
        }
      }

      return value;
    },
    phoneToPattern(value) {
      if (value) {
        if (value.length == 11) {
          value = "(" + value.substring(0, 2) + ") " + value.substring(2, 7) + "-" + value.substring(7, 11);
        }

        return value;
      }
    },
    formatPhoneNumber(value) {
      if (value === null || value === undefined) {
        return null;
      }

      if (value.length === 10) {
        return `(${value.substring(0, 2)}) ${value.substring(
            2,
            6
        )} - ${value.substring(6, 11)}`;
      }

      if (value.length === 11) {
        return `(${value.substring(0, 2)}) ${value.substring(
            2,
            7
        )} - ${value.substring(7, 11)}`;
      }

      return value;
    },
    goTo(route) {
      this.$router.push({
        name: route
      });
    },
    getErrorMessage(error) {
      try {
        let message = error.response.data.message || 'Ocorreu um erro. Tente novamente.';
        if (error.response.data.errors) {
          try {
            return error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
          } catch (e) {
            return message
          }
        }
        return message;
      } catch (e) {
        return error;
      }
    },
    formatMoney: function (value) {
      if (isNaN(value)) {
        return '0,00'
      } else {
        let val = ((value / 100)).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    integerToMoney(value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getIntMoney(formattedMoney) {
      return Math.round(parseFloat(formattedMoney.replace('.', '').replace(',', '.').replace('R$', '')) * 100);
    },
    timeStampToHuman(dateTime) {
      if (!dateTime) {
        return null;
      }

      const date = new Date(dateTime);
      return date.toLocaleString('pt-BR');
    },
    safeGet(object, path, defaultValue = null) {
      const keys = path.split('.');
      let result = object;

      for (const key of keys) {
        if (result === null || result === undefined) {
          return defaultValue;
        }
        result = result[key];
      }

      if (result === undefined) {
        return defaultValue;
      }

      return result;
    },
  }
};
</script>
